import { EnterpriseStatus } from '../enums/enterprise-status.enum';
import { RealmType } from '../enums/realm-type.enum';
import { ServerPermission } from '../enums/server-permission.enum';
import { Serializable, Serialized, SerializeUtil } from '../utils/serialize';
import { Enterprise } from './enterprise';

export const REALM_MEDIA_TYPE = 'application/vnd.io.idaas.admin.api.realm.v1+json';

export class Realm implements Serializable {
  @Serialized() public id: string;
  @Serialized() public type: RealmType;
  @Serialized() public name: string;
  @Serialized() public permissions: ServerPermission[];
  @Serialized() public enterpriseStatus?: EnterpriseStatus;

  @Serialized({
    serialize: instance => instance.serialize(),
    deserialize: Enterprise.deserialize,
  })
  public enterprise?: Enterprise;

  constructor(backEndRealm?: BackEndRealm) {
    if (backEndRealm) {
      this.id = backEndRealm.id;
      this.type = backEndRealm.type;
      this.name = backEndRealm.name;
      this.permissions = backEndRealm.permissions;
      this.enterpriseStatus = backEndRealm.enterprise_status;
    }
  }

  public toBackend(): BackEndRealm {
    return {
      id: this.id,
      type: this.type,
      name: this.name,
      permissions: this.permissions,
      enterprise_status: this.enterpriseStatus,
    };
  }

  public serialize(): string {
    return SerializeUtil.deepSerialize(this);
  }

  public static deserialize(serialized: string | object): Realm {
    return SerializeUtil.deepDeserialize(new Realm(), serialized);
  }
}
export interface BackEndRealm {
  id: string;

  type: RealmType;

  name: string;

  permissions: ServerPermission[];

  /** only if ENTERPRISE */
  enterprise_code?: string;

  /** only if ENTERPRISE */
  enterprise_status?: EnterpriseStatus;

}
